import React from 'react';
import ComplaintsTable from './ComplaintsTable';

const Complaints = () => {
    return ( <><ComplaintsTable/></> );
}
 
export default Complaints;